import { render, staticRenderFns } from "./GestionSolicitudes.vue?vue&type=template&id=65a6b004&scoped=true"
import script from "./GestionSolicitudes.vue?vue&type=script&lang=js"
export * from "./GestionSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./GestionSolicitudes.vue?vue&type=style&index=0&id=65a6b004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6b004",
  null
  
)

export default component.exports